export default __webpack_public_path__ + "static/media/checkbox_unselected.c73576fa.svg";